import * as Yup from 'yup'
import ReCAPTCHA from 'react-google-recaptcha'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { Link as RouterLink, useNavigate } from 'react-router-dom'

import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import useAuth from '../../../hooks/useAuth'
import useIsMountedRef from '../../../hooks/useIsMountedRef'
import { FormProvider, RHFTextField } from '../../../components/hook-form'

import {
  Stack,
  Button,
  Alert,
  InputAdornment,
  Typography,
  TextField,
  Box,
} from '@mui/material'
import { LoadingButton } from '@mui/lab'

import Iconify from '../../../components/Iconify'

import { PATH_AUTH } from '../../../routes/paths'

import config from '../../../utils/config'

export default function LoginForm() {
  const [signInIsReady, setSignInIsReady] = useState(false)

  const navigate = useNavigate()
  const isMountedRef = useIsMountedRef()
  const { login, user } = useAuth()

  const { enqueueSnackbar } = useSnackbar()

  const LoginSchema = Yup.object().shape({
    phoneNumber: Yup.string().required('تلفن همراه را وارد کنید'),
  })

  const defaultValues = {
    phoneNumber: '',
  }

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  })

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods

  const onSubmit = async (data) => {
    try {
      await login(data.phoneNumber)
      enqueueSnackbar('کد فعال سازی برای شما ارسال شد')
      navigate(navigate(PATH_AUTH.verify))
    } catch (error) {
      console.error(error)
      reset()
      if (isMountedRef.current) {
        setError('afterSubmit', error)
      }
    }
  }

  const handleCaptchaChange = (value) => {
    if (value) {
      setSignInIsReady(true)
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && (
          <Alert severity='error'>
            {errors.afterSubmit.response.data.error}
          </Alert>
        )}

        <RHFTextField
          autoComplete='off'
          name='phoneNumber'
          label='شماره موبایل'
          inputProps={{ maxLength: 11 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position='start'>
                <Iconify icon='carbon:phone-filled' width={24} height={24} />
              </InputAdornment>
            ),
          }}
        />

        <LoadingButton
          sx={{ my: 2 }}
          fullWidth
          size='large'
          type='submit'
          variant='contained'
          loading={isSubmitting}
        >
          دریافت کد تایید
        </LoadingButton>
      </Stack>

      <Stack spacing={2}>
        <Typography
          variant='h6'
          // display='block'
          display='none'
          gutterBottom
          component='div'
          sx={{ margin: '30px auto 0' }}
        >
          00:01:59
        </Typography>
        <Typography
          variant='subtitle2'
          gutterBottom
          display='none'
          component='div'
          sx={{ margin: '30px auto 0', textAlign: 'center' }}
        >
          بعد از گذشته 2 دقیقا می توانید دوباره درخواست رمز دهید
        </Typography>
      </Stack>

      {/* I'm not a robot */}
    </FormProvider>
  )
}
